// extracted by mini-css-extract-plugin
export default {"container":"Error_container__kVnA6","errorContainer":"Error_errorContainer__RB9n4","errorMsg":"Error_errorMsg__VkkoC"};